import { tCaseComponentsLib } from '@/Interfaces/caseComponentsLib';
import { shields } from '@/Constants/caseComponentsLib/shields';
import { shelves } from '@/Constants/caseComponentsLib/shelves';
import { drawers } from '@/Constants/caseComponentsLib/drawers';
import { separators } from '@/Constants/caseComponentsLib/separators';
import { accessories } from '@/Constants/caseComponentsLib/accessories';
import { modelMeta } from '@/Constants/modelMeta';

export const caseComponentsLib: tCaseComponentsLib = [
    ...shields,
    ...shelves,
    ...drawers,
    ...separators,
    ...accessories,
    {
        id: 'sh_chpu_hard',
        xmlId: '25aab655-5770-61b3-1174-63e7cc1cdf17',
        name: 'Кронштейн полок SK, HSK шкафа HARD (2 шт.) (ставится автоматически!)',
        type: 'other',
        caseModels: [ 'HARD-1000', 'HARD-2000' ],
        blenderName: 'shelf_chpu_hard',
        image: '',
    },
    // Из чего состоят HARD-шкафы
    {
        id: 'body_hard_1000',
        xmlId: 'f32c4b24-0494-9cf5-453d-3de878599ede',
        name: 'Корпус шкафа HARD 1000',
        type: 'other',
        caseModels: [],
        blenderName: '',
        image: 'dist/src/img/case_hard1000.png',
    },
    {
        id: 'body_hard_2000',
        xmlId: '4c2666a2-8a7e-e714-222c-fbf0df089236',
        name: 'Корпус шкафа HARD 2000',
        type: 'other',
        caseModels: [],
        blenderName: '',
        image: 'dist/src/img/case_hard2000.png',
    },
    {
        id: 'frame_hard_1000',
        xmlId: 'd89fd5ef-c5f8-3b4c-ff05-240fe5c6e0d1',
        name: 'Рама шкафа HARD 1000',
        type: 'other',
        caseModels: [],
        blenderName: '',
        image: 'dist/src/img/frame_hard1000.png',
    },
    {
        id: 'frame_hard_2000',
        xmlId: 'cecebd94-bc4a-db66-4401-092319f18363',
        name: 'Рама шкафа HARD 2000',
        type: 'other',
        caseModels: [],
        blenderName: '',
        image: 'dist/src/img/frame_hard2000.png',
    },

];

export const smallCaseBlenderNames = modelMeta
    .filter(x=> x.box?.isSmall && x.name !== 'perfo_screen_tcs_50x43' && x.name !== 'set_niches_tc_1995')
    .map(x => x.name);
export const smallCasePrototypeIds = caseComponentsLib
    .filter(x =>
        smallCaseBlenderNames.includes(x.blenderName))
    .map(x => x.id);

export type tComponentsBlenderNameLight =
    'shelfS_tcsh_43x47' |
    'shelfL_tcsh_95x47' |
    'wardrobe_kit_tcsh' |
    'drawerS_tcf_42x45' |
    'drawerL_tcf_87x45' |
    'drawer_tcf_39x45' |
    'tc_shelf_chpu_sk_40' |
    'tc_shelf_chpu_sk_50' |
    'tc_shelf_chpu_hsk_63' |
    'perfo_screen_tcs_50x43' |
    'lateral_screen_ms' |
    'ver_wall_tcd_1800' |
    'ver_wall_tcd_1800_2' |
    'ver_wall_tcd_900';

export type tComponentsBlenderNameMiddle =
    'perfo_screen_amh_tc' |
    'shelf_amh_tc' |
    'shelf_chpu_amh_tc_40' |
    'shelf_chpu_amh_tc_50' |
    'shelf_chpu_amh_tc_63' |
    'drawer_amh_tc_60' |
    'drawer_amh_tc_125';

export type tComponentsBlenderNameHard =
    'drawer_hard_60' |
    'drawer_hard_125' |
    'drawer_hard_265' |
    'shelf_hard' |
    'sliding_shelf_hard' |
    'shelf_chpu_hard_40_s1' |
    'shelf_chpu_hard_50_s1' |
    'shelf_chpu_hard_63_s1' |
    'shelf_chpu_hard_40_s2' |
    'shelf_chpu_hard_50_s2' |
    'shelf_chpu_hard_63_s2' |
    'shelf_chpu_hard_40_s3' |
    'shelf_chpu_hard_50_s3' |
    'shelf_chpu_hard_63_s3' |
    'shelf_chpu_hard' |
    'perfo_screen_hard' |
    'table_hard_1000';



export const componentsBlenderNameLight = [
    'shelfS_tcsh_43x47',
    'shelfL_tcsh_95x47',
    'wardrobe_kit_tcsh',
    'drawerS_tcf_42x45',
    'drawerL_tcf_87x45',
    'drawer_tcf_39x45',
    'tc_shelf_chpu_sk_40',
    'tc_shelf_chpu_sk_50',
    'tc_shelf_chpu_hsk_63',
    'perfo_screen_tcs_50x43',
    'lateral_screen_ms',
    'ver_wall_tcd_1800',
    'ver_wall_tcd_1800_2',
    'ver_wall_tcd_900',
];
export const componentsBlenderNameMiddle = [
    'perfo_screen_amh_tc',
    'shelf_amh_tc',
    'shelf_chpu_amh_tc_40',
    'shelf_chpu_amh_tc_50',
    'shelf_chpu_amh_tc_63',
    'drawer_amh_tc_60',
    'drawer_amh_tc_125',
];
export const componentsBlenderNameHard = [
    'drawer_hard_60',
    'drawer_hard_125',
    'drawer_hard_265',
    'shelf_hard',
    'sliding_shelf_hard',
    'shelf_chpu_hard_40_s1',
    'shelf_chpu_hard_50_s1',
    'shelf_chpu_hard_63_s1',
    'shelf_chpu_hard_40_s2',
    'shelf_chpu_hard_50_s2',
    'shelf_chpu_hard_63_s2',
    'shelf_chpu_hard_40_s3',
    'shelf_chpu_hard_50_s3',
    'shelf_chpu_hard_63_s3',
    'shelf_chpu_hard',
    'perfo_screen_hard',
    'table_hard_1000',
];

export const accessoryPrototypeIdForShields= [
    'wh_key_hol',
    'hexagon_hh',
    'pap_towel_pth',
    'box_hol_200_SPBH',
    'sh_lar_lsh',
    'tray_hol_a4',
    'ushm_hol',
    'hook_hk_2_80',
];

export type tAccessoriesBlenderName =
    'wh_key_holder' |
    'hexagon_holder_hh' |
    'paper_towel_holder_pth' |
    'plastic_box_holder_200_SPBH' |
    'shelf_large_lsh' |
    'tray_holder_a4' |
    'ushm_holder' |
    'hook_hk_2_80' |
    'plastic_box_400x230x150';

